import gql from 'graphql-tag';

import {Error} from './__generated/Error';
import FragmentWrapper from './FragmentWrapper';

export const ERROR_FRAGMENT = gql`
  fragment Error on ErrorNode {
    message
  }
`;

export const ErrorFragment: FragmentWrapper<Error> = {
  fragment: ERROR_FRAGMENT,
  fragmentName: 'Error',
};

export function isError(data: {__typename?: string}): data is Error {
  return data.__typename === 'ErrorNode';
}
